import React from 'react';

import { getPayerBaseUrl } from '../../utils/URLBuilder';

/**
 * Shown when a user is signed in with a customer-only account
 * (has 'customer' role but not 'client'). Offers a link to the
 * payer/customer site and a way to sign in with a different account.
 */
export default function CustomerOnlyNotice({ onSignInDifferent }) {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-start gap-3 text-start px-4 mt-5"
      style={{ width: '100%', maxWidth: '780px' }}
    >
      <h2 className="text-white mb-3" style={{ fontWeight: 700 }}>Wrong account type</h2>
      <p className="text-white-50 mb-4" style={{ fontSize: '1.2rem', lineHeight: 1.6 }}>
        You already have an account as a customer where you can track who and where you tip.
      </p>
      <a
        href={getPayerBaseUrl()}
        className="btn btn-lg"
        style={{ backgroundColor: '#ff0098', color: 'white', fontWeight: 600, borderRadius: '8px', padding: '12px 32px' }}
      >
        Open customer site
      </a>
      <button
        className="btn btn-link text-white-50 mt-2 p-0"
        style={{ fontSize: '0.95rem' }}
        onClick={onSignInDifferent}
      >
        Sign in with a different account
      </button>
    </div>
  );
}
